import React from 'react';
import Autocomplete, {
    createFilterOptions,
} from '@material-ui/lab/Autocomplete';
import { OutlinedInput } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import Close from 'src/assets/images/CloseProduct.svg';
import DownArrowFilter from 'src/assets/images/DownArrowFilter.svg';
import Search from 'src/assets/images/Search.svg';
import { logErrorToConsole } from 'src/utils/util';
import {
    Icon,
    InputContainer,
    useStyles,DivContainer,

} from './AutoComplete.styled';
import ChipComponent from 'src/common/refactoredComponents/chipComponent';
import { sizes } from 'src/styles/Media.styled';

export default function AutoComplete(props) {
    const filterOptions = createFilterOptions({
        trim: true,
        stringify: (option) =>
            option
                ? option[props.filterField] || option[props.field] || ''
                : option[props.field] || '',
    });

    const classes = useStyles({
        mbBorderRadius: props.mbBorderRadius,
        paddingLeft: props.paddingLeft,
        fontSize: props.fontSize,
        border: props.border,
        optionPadding: props.optionPadding,
        SearchGrayInactive: props.SearchGrayInactive,
        value: props.value,
        mbPaddingLeft: props.mbPaddingLeft,
        zIndex: props.zIndex,
        hoverBgColor: props.hoverBgColor,
        marginLeft: props.marginLeft,
        dropdownHeight: props.dropdownHeight,
        quickOrderPadding: props.quickOrderPadding,
        closeIconDisplay: props.closeIconDisplay,
        fontSizePlaceholder: props.fontSizePlaceholder,
        marginLeftOption: props.marginLeftOption,
    });

    // const { t } = useTranslation();

    return (
        <div
            style={{
                position: 'relative',
                width:
                    window.innerWidth < sizes.mobileDevice
                        ? props.mbWidth && props.isPhysicianField
                            ? props.mbWidth
                            : ''
                        : window.innerWidth >= sizes.mobileDevice
                        ? props.width && props.isPhysicianField
                            ? props.width
                            : ''
                        : '',
            }}
        >
            <Autocomplete
                filterOptions={
                    props.surgeryShipTo ? (options) => options : filterOptions
                }
                id={props.id}
                options={props.options}
                getOptionLabel={(option) =>
                    option ? option[`${props.field}`] || '' : ''
                }
                getOptionSelected={(option, value) =>
                    option &&
                    value &&
                    option[`${props.optionValue}`] ===
                        value[`${props.optionValue}`]
                }
                value={props.value === '' ? null : props.value}
                renderOption={props.itemTemplate}
                onChange={(event, value) =>
                    props.onChange(value ? value : '', false)
                }
                style={props.style}
                classes={{
                    listbox: props.showScrollBar
                        ? classes.listRoot
                        : props.dropdownHeight
                        ? classes.dynamicHeight
                        : '',
                    option: classes.options,
                    popper: classes.popper,
                    paper: props.detailsMargin
                        ? classes.detailsPaper
                        : props.showSearchIcon
                        ? classes.paper
                        : null,
                    endAdornment: classes.endAdornment,
                }}
                onOpen={props.onOpen}
                open={props.open}
                onClose={props.onClose}
                loading={props.loading}
                onFocus={props.onFocus}
                noOptionsText={props.noOptionsText}
                onInputChange={props.onInputChange}
                inputValue={props.inputValue}
                disabled={props.disabled}
                onKeyPress={props.onKeyPress}
                onBlur={props.onBlur}
                renderInput={(params) => (
                    <DivContainer
                        ref={params.InputProps.ref}
                        landscapeWidth={props.landscapeWidth || props.mbWidth}
                        
                    >
                        <OutlinedInput
                            id="outlined-adornment-weight"
                            classes={{
                                root: classes.customTextField,
                                notchedOutline: classes.notchedOutline,
                            }}
                            startAdornment={
                                props.showSearchIcon &&
                                props.inputValue.length < 1 ? (
                                    <InputAdornment position="start">
                                        <Icon
                                        id="autocomplete-search-icon"
                                            src={
                                                props.SearchGrayInactive ||
                                                Search
                                            }
                                            height={props.searchIconHeight}
                                            width={props.searchIconWidth}
                                            onClick={() => {
                                                try {
                                                    !props.disabled
                                                        ? props.onChange('')
                                                        : null;
                                                } catch (error) {
                                                    logErrorToConsole(error);
                                                }
                                            }}
                                        />
                                    </InputAdornment>
                                ) : (
                                    ''
                                )
                            }
                            endAdornment={
                                props.isFromShiptoAddress &&
                                props.value?.defaultAddress ? (
                                    props.value &&
                                    props.value !== '' &&
                                    props.value?.defaultAddress && (
                                        <>
                                            <div
                                                style={{
                                                    // position: 'absolute',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    top: '50%',
                                                    left: `${
                                                        props?.isMobile &&
                                                        props?.inputValue
                                                            ?.length +
                                                            3 >
                                                            31
                                                            ? 31
                                                            : !props?.isMobile &&
                                                              props?.inputValue
                                                                  ?.length +
                                                                  3 >
                                                                  37
                                                            ? 37
                                                            : props?.inputValue
                                                                  ?.length +
                                                                  3 || 0
                                                    }ch`,
                                                    // transform:
                                                    //     'translateY(-50%)',
                                                    zIndex: 1,
                                                    paddingRight: '40px',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        whiteSpace: 'nowrap',
                                                        overflow: 'hidden',
                                                        textOverflow:
                                                            'ellipsis',
                                                    }}
                                                ></span>

                                                <ChipComponent
                                                    height={'auto'}
                                                    label="Default"
                                                    color="#4F4F4F"
                                                    borderRadius="20px"
                                                    isFromAutoComplete={true}
                                                    desktopPadding={'5px'}
                                                    style={{
                                                        marginLeft: '2ch',
                                                        maxWidth:
                                                            'calc(100% - 40px)',
                                                        overflow: 'hidden',
                                                        textOverflow:
                                                            'ellipsis',
                                                    }}
                                                />
                                            </div>
                                            <InputAdornment position="end">
                                                {props.value !== '' &&
                                                props.value !== undefined &&
                                                props.value?.defaultAddress ? (
                                                    <Icon
                                                        id="autocomplete-clear-icon"
                                                        src={Close}
                                                        height={props.height}
                                                        onClick={() => {
                                                            try {
                                                                !props.disabled
                                                                    ? props.onChange(
                                                                          '',
                                                                          true
                                                                      )
                                                                    : null;
                                                                // props.onClose &&
                                                                //     props.onClose();
                                                            } catch (error) {
                                                                logErrorToConsole(error);
                                                            }
                                                        }}
                                                        opacity={
                                                            props.disabled
                                                                ? '0.5'
                                                                : '1'
                                                        }
                                                    />
                                                ) : (
                                                    <Icon
                                                        id="autocomplete-down-arrow-icon"
                                                        src={DownArrowFilter}
                                                        height={
                                                            props.height ||
                                                            '8px'
                                                        }
                                                        onClick={() => {
                                                            try {
                                                                !props.disabled
                                                                    ? props.onChange(
                                                                          props.value,
                                                                          true
                                                                      )
                                                                    : null;
                                                                props.onClose &&
                                                                    props.onClose();
                                                            } catch (error) {
                                                                logErrorToConsole(error);
                                                            }
                                                        }}
                                                        opacity={
                                                            props.disabled
                                                                ? '0.5'
                                                                : '1'
                                                        }
                                                    />
                                                )}
                                            </InputAdornment>
                                        </>
                                    )
                                ) : (!props.isFromPhysician &&
                                      props.isFromSurgery) ||
                                  props.isFromMazorCase ? (
                                    <InputAdornment position="end">
                                        {props.value !== '' &&
                                        props.value !== undefined ? (
                                            <Icon
                                                id="autocomplete-clear-icon"
                                                src={Close}
                                                height={props.height}
                                                onClick={() => {
                                                    try {
                                                        !props.disabled
                                                            ? props.onChange(
                                                                  '',
                                                                  true
                                                              )
                                                            : null;
                                                        props.onClose &&
                                                            props.onClose();
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                                opacity={
                                                    props.disabled ? '0.5' : '1'
                                                }
                                            />
                                        ) : (
                                            <Icon
                                                id="autocomplete-down-arrow-icon"
                                                src={DownArrowFilter}
                                                height={props.height || '8px'}
                                                onClick={() => {
                                                    try {
                                                    !props.disabled
                                                        ? props.onChange(
                                                              props.value,
                                                              true
                                                          )
                                                        : null;
                                                    props.onClose &&
                                                        props.onClose();
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                                opacity={
                                                    props.disabled ? '0.5' : '1'
                                                }
                                            />
                                        )}
                                    </InputAdornment>
                                ) : props.isFromShiptoAddress &&
                                  props.inputValue &&
                                  props.inputValue !== '' &&
                                  !props.value?.defaultAddress ? (
                                    <InputAdornment position="end">
                                        {props.value !== '' &&
                                        props.value !== undefined ? (
                                            <Icon
                                                id="autocomplete-clear-icon"
                                                src={Close}
                                                height={props.height}
                                                onClick={() => {
                                                    try {
                                                        !props.disabled
                                                            ? props.onChange(
                                                                  '',
                                                                  true
                                                              )
                                                            : null;
                                                        // props.onClose &&
                                                        //     props.onClose();
                                                    } catch (error) {
                                                        logErrorToConsole(error);
                                                    }
                                                }}
                                                opacity={
                                                    props.disabled ? '0.5' : '1'
                                                }
                                            />
                                        ) : (
                                            <Icon
                                                id="autocomplete-down-arrow-icon"
                                                src={DownArrowFilter}
                                                height={props.height || '8px'}
                                                onClick={() => {
                                                    !props.disabled
                                                        ? props.onChange(
                                                              props.value,
                                                              true
                                                          )
                                                        : null;
                                                    props.onClose &&
                                                        props.onClose();
                                                }}
                                                opacity={
                                                    props.disabled ? '0.5' : '1'
                                                }
                                            />
                                        )}
                                    </InputAdornment>
                                ) : (
                                    !props.isFromPhysician &&
                                    props.isFromSurgery && (
                                        <InputAdornment position="end">
                                            {props.value !== '' &&
                                            props.value !== undefined ? (
                                                <Icon
                                                    id="autocomplete-clear-icon"
                                                    src={Close}
                                                    height={props.height}
                                                    onClick={() => {
                                                        try {
                                                            !props.disabled
                                                                ? props.onChange(
                                                                      '',
                                                                      true
                                                                  )
                                                                : null;
                                                            props.onClose &&
                                                                props.onClose();
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                    opacity={
                                                        props.disabled
                                                            ? '0.5'
                                                            : '1'
                                                    }
                                                />
                                            ) : (
                                                <Icon
                                                    id="autocomplete-down-arrow-icon"
                                                    src={DownArrowFilter}
                                                    height={
                                                        props.height || '8px'
                                                    }
                                                    onClick={() => {
                                                        try {
                                                            !props.disabled
                                                                ? props.onChange(
                                                                      props.value,
                                                                      true
                                                                  )
                                                                : null;
                                                            props.onClose &&
                                                                props.onClose();
                                                        } catch (error) {
                                                            logErrorToConsole(error);
                                                        }
                                                    }}
                                                    opacity={
                                                        props.disabled
                                                            ? '0.5'
                                                            : '1'
                                                    }
                                                />
                                            )}
                                        </InputAdornment>
                                    )
                                )
                            }
                            placeholder={props.placeholder}
                            style={
                                props.autoCompleteInputFieldStyle ||
                                InputContainer
                            }
                            isSurgery={true}
                            labelWidth={0}
                            inputRef={props.inputRef}
                            {...params.inputProps}
                        />
                    </DivContainer>
                )}
            />
        </div>
    );
}

AutoComplete.defaultProps = {
    isFromPhysician: true,
};
